import { Component, OnInit, OnChanges, OnDestroy, Input, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { BannerMessage } from '@model';
import { Store } from '@ngrx/store';
import * as fromInformationStore from '@core/store';
import * as fromConfigurationStore from "@appStore/configuration";
import { SubSink } from 'subsink';

@Component({
    selector: 'app-system-message-pane',
    templateUrl: './system-message-pane.component.html',
    //changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SystemMessagePaneComponent implements OnInit, OnDestroy {

  @Input()
  isLoggedIn: boolean;
  @Input()
  bannerMessages: BannerMessage[] = [];
  
  //messages: BannerMessage[] = [];
  preClosureMessage = { id: -1, isVisible: false, message: '', content: '', severity: 2, icon: '' } as BannerMessage;
  startPageBanner = { id: -2, isVisible: false, message: '', content: '', severity: 2, icon: '' } as BannerMessage;
  private subs = new SubSink();
  allMessagesDismissed = false;

  constructor(private informationStore: Store<fromInformationStore.InformationState>,
    private changeDetectorRef: ChangeDetectorRef) { }

    ngOnInit() {
    this.allMessagesDismissed = this.bannerMessages && this.bannerMessages.every((message) => message.isVisible === false);

    this.subs.sink = this.informationStore.select(fromInformationStore.getPreClosureBanner).subscribe(preclosureMessage => {
      //console.log(`system-message-pane\tgetPreClosureBanner`, preclosureMessage);
      if (preclosureMessage){
        this.preClosureMessage = preclosureMessage;
        //console.log(`system-message-pane\tsetPreClosureMessage`);
        this.changeDetectorRef.detectChanges();
      }
    });

    // Start page banner only exists when user is not logged in
    this.subs.sink = this.informationStore.select(fromInformationStore.getStartPageBanner).subscribe(startPageBanner => {
      //console.log(`system-message-pane\tgetStartPageBanner`, startPageBanner);
      if (startPageBanner){
        this.startPageBanner = startPageBanner;
        //console.log(`system-message-pane\tsetStartPageBanner`);
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        
        switch (propName) {
          case 'bannerMessages':
            //console.log(`system-message-pane\tngOnChanges\tbannerMessages`, this.bannerMessages);
            if (this.bannerMessages.length > 0) {
              this.allMessagesDismissed = this.bannerMessages && this.bannerMessages.every((message) => message.isVisible === false);
            }
            break;
          }
        }
      }
  }

  ngOnDestroy() {
    this.changeDetectorRef.detach();
    this.subs.unsubscribe();
  }

  onMessageDismissed(id: number){
    //console.log(`system-message-pane\tonDismissed`, id);
    if (id === -1) {
      this.informationStore.dispatch(new fromInformationStore.DismissPreClosureBanner());
    } else {
      this.informationStore.dispatch(new fromInformationStore.DismissBanner(id));
    }
  }
}
